<template>
  <div class="loan_container">
    <div class="loan_contant">
      <div class="loan_box">
        <van-form @submit="onSubmit"
                  validate-trigger='onSubmit'
                  :validate-first="true">
          <van-cell-group class="group"
                          id="loan_group"
                          :border='false'>
            <van-field placeholder="请输入姓名"
                       label="姓名"
                       name="nickName"
                       :maxlength='50'
                       center
                       v-model.trim="loanUserInfor.nickName"
                       clearable
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
            <van-field v-if="loanUserInfor.phoneNumber"
                       center
                       placeholder="手机号"
                       label="手机号"
                       name="tel"
                       type="tel"
                       :value="loanUserInfor.phoneNumber"
                       readonly
                       :rules="[{ required: true, message: '' }]"
                       label-width="96px" />
            <van-field label="达标日期"
                       name="data"
                       center
                       readonly
                       placeholder="请选择日期"
                       v-model="list.data"
                       :rules="[{ required: true, message: '' }]"
                       @click="show = true"
                       label-width="96px" />
            <!-- <van-calendar v-model="show"
                          :value="list.data"
                          @confirm="onConfirm"
                          :min-date="minDate"
                          :max-date="maxDate" /> -->

          </van-cell-group>
          <van-button round
                      block
                      class="loan_submit"
                      color="#EE0A25"
                      native-type="submit">立即提交</van-button>
        </van-form>
        <!-- 弹窗 -->
        <van-dialog v-model="showDialog"
                    @confirm="confirm"
                    confirmButtonText='我知道了'>
          <div class="loan_dig">
            <van-icon name="passed"
                      v-if="returnStatus"
                      size="49"
                      color="rgba(25, 193, 92, 1)" />
            <van-icon name="warning-o"
                      v-if="!returnStatus"
                      size="49"
                      color="rgba(255, 145, 0, 1)" />
            <div class="loan_tip">{{tip}}</div>
          </div>
        </van-dialog>
        <!-- 日期弹窗 -->
        <van-popup v-model="show"
                   position="bottom">
          <van-datetime-picker :formatter="formatter"
                               round
                               type="date"
                               @confirm="onConfirm"
                               @cancel='cancel'
                               :value="list.data"
                               title="请选择日期"
                               :min-date="minDate"
                               :max-date="maxDate"
                               v-model="currentDate" />
        </van-popup>
      </div>
    </div>

  </div>
</template>

<script>
import {
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Calendar,
  Cell,
  Icon,

} from "vant";
import { mapGetters } from "vuex";
import loading from "../../components/loading/loading";
import serviceApply from "../../api/apply/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.Component.name]: Dialog.Component,
    [Calendar.name]: Calendar,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    loading
  },
  props: {},
  data () {
    return {
      currentDate: new Date(),
      // 弹窗层
      showDialog: false,
      // 弹出层显示图标
      returnStatus: false,
      // 弹出层提示
      tip: "",
      //加载中loading
      isLoading: false,
      list: {
        date: '',
      },
      // 日期取件
      show: false,
      minDate: new Date(),
      maxDate: new Date(),
      // 拷贝数据
      loanUserInfor: {},
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    formatter (type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      } else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    //日期确认
    formatDate (date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm (date) {
      this.list.data = `${this.formatDate(date)}`;
      this.show = false
    },
    cancel () {
      this.show = false
    },
    // 提交
    onSubmit () {
      this.isLoading = true
      const postData = {
        mallUserName: this.loanUserInfor.nickName,
        phoneNumber: this.loanUserInfor.phoneNumber,
        dateTime: this.list.data
      }
      serviceApply
        .paymentForGoodsToOwner(postData)
        .then((res) => {
          console.log(res.statusCode);
          if (res.statusCode == 200) {
            this.isLoading = false
            if (res.data.status == true) {
              this.returnStatus = true
              this.showDialog = true
              this.tip = res.data.description
            } else {
              this.returnStatus = false
              this.showDialog = true
              this.tip = res.data.description
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取近六个月日期范围
    getChangeRangeData () {
      this.isLoading = true
      serviceApply
        .sixMonths()
        .then((res) => {
          if (res.statusCode == 200) {
            this.isLoading = false
            this.minDate = new Date(res.data.beginTime)
            this.maxDate = new Date(res.data.endTime)
            this.currentDate = new Date(res.data.endTime)
          } else {
            Toast(errors);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 弹窗确认
    confirm () {
      this.$router.push({ name: "shopkeeper" });
    }
  },
  created () { },
  mounted () {
    // 深拷贝用户数据（用同一个数据会影响其他页面的同一个值）
    this.loanUserInfor = JSON.parse(JSON.stringify(this.userInfo))
    // 获取近六个月日期范围
    this.getChangeRangeData()
  }
};
</script>
<style lang="less" >
.loan_container {
  height: 100vh;
  overflow: hidden;
  // .van-field--error .van-field__control,
  // .van-field--error .van-field__control::placeholder {
  //   color: #ccc !important;
  // }
  .van-picker__confirm {
    color: #ee0a25;
  }
  .loan_contant {
    padding: 8px 16px 24px 16px;
  }
  .loan_box {
    height: 156px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
  }
  .van-cell {
    height: 52px;
  }
  // .van-cell__value {
  //   line-height: 32px;
  // }
  // ::v-deep .van-field__label--required:before {
  //   position: absolute;
  //   left: 6px;
  //   top: 13px;
  // }
  .van-field__label:before {
    content: '*';
    color: rgba(240, 7, 36, 1);
    position: absolute;
    left: 15px;
    top: 13px;
  }
  .van-field {
    padding-left: 25px;
  }
  .loan_dig {
    height: 124px;
    padding-top: 24px;
    text-align: center;
  }
  .loan_tip {
    margin-top: 20px;
    font-size: 14px;
    color: #000000;
  }
  .loan_submit {
    margin-top: 24px;
  }
  // ::v-deep .van-field--error .van-field__control,
  // .van-field--error .van-field__control::placeholder {
  //   color: #fefefe;
  // }
}
</style>